import history from 'services/history';
import { getWebsitesService, updateWebsiteService } from 'services/website';

export const setLoading = (dispatch, value) => {
  dispatch({
    type: 'SET_LOADING',
    payload: value,
  });
};

const mapPriorityStatus = (priority: number) => {
  switch (priority) {
    case 0:
      return undefined;
    case 1:
      return false;
    case 2:
      return true;
    default:
      true;
  }
};

export const getWebsites = async (
  dispatch,
  page,
  search,
  filter,
  clouds,
  order,
  controller,
) => {
  setLoading(dispatch, true);
  try {
    const { data } = await getWebsitesService(
      {
        ...search,
        page,
        filter,
        clouds,
        [`${order?.column}_order`]: mapPriorityStatus(order?.value),
      },
      controller,
    );

    dispatch({
      type: 'GET_WEBSITES',
      payload: data,
    });
    setLoading(dispatch, false);
  } catch (e) {
    if (e.message !== 'canceled') setLoading(dispatch, false);
    if (e?.response?.status === 404) {
      history.push('/404');
    }
  }
};

export const updateWebsite = async (dispatch, field, value, id) => {
  try {
    const { data } = await updateWebsiteService(id, {
      [field]: value,
    });

    dispatch({
      type: 'UPDATE_WEBSITE',
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: 'UPDATE_WEBSITE_ERROR',
      payload: e?.response?.data,
    });
  }
};

export const updateField = (dispatch, field, value, id) => {
  dispatch({
    type: 'UPDATE_FIELD',
    payload: {
      field,
      value,
      id,
    },
  });
};
